import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiDatagrip,
  SiIntellijidea,
  SiWindows,
  SiKalilinux,
  SiVmware,
  SiSourcetree,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiIntellijidea />
        <div className="tech-label">IntelliJ IDEA</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKalilinux />
        <div className="tech-label">Kali Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiWindows />
        <div className="tech-label">Windows</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <div className="tech-label">VS Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSourcetree />
        <div className="tech-label">Source Tree</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVmware />
        <div className="tech-label">VMware</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <div className="tech-label">Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDatagrip />
        <div className="tech-label">DataGrip</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
